import React, { useEffect, useState } from 'react';
import { getEstimatedPrice, gneerateBill } from "../../Api/Api";
import { useNotification } from "../Notification/NotificationContext";

function BillingModal({ jobCard, customer, show, handleClose }) {
    const [selectedJobCard, setSelectedJobCard] = useState(jobCard);
    const [estimatedPrice, setEstimatedPrice] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [extraCharges, setExtraCharges] = useState(0);
    const [comment, setComment] = useState("");           
    const [finalPrice, setFinalPrice] = useState(0);
    const [redeemPoints, setRedeemPoints] = useState(false);
    const { showNotification } = useNotification();

    const loyaltyCard = customer?.loyaltyCard;
    const hasActiveCard = loyaltyCard?.status === "ACTIVE";
    const pointsBalance = loyaltyCard?.loyaltyPointsBalance || 0;
    const freeServicesLeft = hasActiveCard ? (12 - loyaltyCard.serviceCountUsed) : 0;

    useEffect(() => {
        getEstimatedPrice(selectedJobCard)
            .then((res) => {
                setEstimatedPrice(res.data);
            })
            .catch((error) => {
                showNotification(error.message, "error");
            });
    }, [jobCard.id]);

    useEffect(() => {
        const discountAmount = (discount / 100) * estimatedPrice;
        setFinalPrice(estimatedPrice - discountAmount + parseFloat(extraCharges || 0));
    }, [discount, estimatedPrice, extraCharges]);

    const handleConfirmBilling = () => {
        gneerateBill(selectedJobCard, discount, redeemPoints, extraCharges, comment)
            .then(response => {
                showNotification("Bill Generated Successfully!", "success");
                handleClose();
            })
            .catch((error) => {
                showNotification(error.message, "error");
            });
    };

    return (
        <div
            className={`fixed inset-0 z-50 ${show ? 'block' : 'hidden'} bg-gray-800 bg-opacity-50`}
            onClick={handleClose}
        >
            <div
                className="relative mx-auto mt-10 w-full max-w-4xl bg-white p-6 rounded-lg shadow-lg"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-semibold text-gray-800">
                        Billing for Job Card #{jobCard.id}
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        ✕
                    </button>
                </div>

                <div className="mt-4 space-y-4">
                    <div className="flex justify-between">
                        <span className="font-semibold text-gray-700">Estimated Price:</span>
                        <span className="text-blue-600">₹ {estimatedPrice?.toFixed(2)}</span>
                    </div>

                    {/* Discount input */}
                    <div>
                        <label htmlFor="discount" className="block font-semibold text-gray-700">
                            Discount (%)
                        </label>
                        <input
                            id="discount"
                            type="number"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter discount percentage"
                        />
                    </div>

                    <div>
                        <label htmlFor="extraCharges" className="block font-semibold text-gray-700">
                            Extra Charges (₹)
                        </label>
                        <input
                            id="extraCharges"
                            type="number"
                            value={extraCharges}
                            onChange={(e) => setExtraCharges(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter extra charges"
                        />
                    </div>

                    <div>
                        <label htmlFor="comment" className="block font-semibold text-gray-700">
                            Comment (Reason for Extra Charges)
                        </label>
                        <textarea
                            id="comment"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            rows={3}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Add reason for extra charges"
                        />
                    </div>

                    {hasActiveCard && (
                        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                            <p className="font-semibold text-yellow-700">🌟 Loyalty Card Benefits</p>
                            <p className="text-sm">Free Services Left: {freeServicesLeft}</p>
                            <p className="text-sm">Available Points: {pointsBalance}</p>

                            {pointsBalance > 0 && (
                                <label className="flex items-center mt-2 space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={redeemPoints}
                                        onChange={(e) => setRedeemPoints(e.target.checked)}
                                        className="h-4 w-4 text-yellow-600 border-gray-300 rounded"
                                    />
                                    <span className="text-sm text-gray-700">
                                        Redeem {Math.min(pointsBalance, estimatedPrice).toFixed(2)} points on this bill
                                    </span>
                                </label>
                            )}
                        </div>
                    )}

                    <div className="flex justify-between">
                        <span className="font-semibold text-gray-700">Final Price:</span>
                        <span className="text-green-600 text-lg">₹ {finalPrice?.toFixed(2)}</span>
                    </div>
                </div>

                <div className="mt-6 flex justify-end space-x-4">
                    <button
                        onClick={handleClose}
                        className="px-6 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleConfirmBilling}
                        className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                        Confirm Billing
                    </button>
                </div>
            </div>
        </div>
    );
}

export default BillingModal;
